import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Recaudo } from '../../models/generic/Recaudo';
import { RecaudosService } from '../../services/recaudos.service';
import { RecaudoPrograma } from '../../models/generic/RecaudoPrograma';
import { Maestro_Aliados } from '../../models/generic/Maestro_Aliados';
import { SeleccionarArchivoComponent } from '../seleccionararchivo/seleccionararchivo.component';

@Component({
  selector: 'recaudos',
  templateUrl: './recaudos.component.html',
  styleUrls: ['./recaudos.component.scss']
})
export class RecaudosComponent implements OnInit{
  TIPO_CONSULTA_PENDIENTES: string = 'PENDIENTES';
  TIPO_CONSULTA_NORMAL: string = 'NORMAL';
  
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<Recaudo>;
  columnasEncabezado: string[] = ['fechaGeneracion', 'aliado', 'descripcionEstado', 'descripcionPrograma', 'asistencias', 'valorEnviado', 'usuario', 'fechaRespuesta', 'acciones'];
  listaAliados: Maestro_Aliados[] = [];
  listaRecaudosPrograma: RecaudoPrograma[] = [];
  listaDatos: Recaudo[] = [];
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('appconfirmacionCompleto', {static: false}) _appconfirmacionCompleto: ConfirmacionGenericaComponent;
  @ViewChild('appseleccionararchivo', {static: false}) _appseleccionararchivo: SeleccionarArchivoComponent;
  itemSeleccionado: Recaudo;
  textoMostrarAnulacion: string = '¿Esta seguro de anular el procesamiento de recaudo?';
  textoMostrarCompletado: string = '¿Esta seguro de marcar el documento como completo?';
  tituloConfirmacion: string = 'Anular';
  tituloConfirmacionCompletado: string = 'Marcar completado';
  textoMostrarRespuesta: string = 'Carque de archivo de respuesta';
  filtroArchivo: string = '';
  ultimaConsulta: string = '';
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public recaudosService: RecaudosService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.IniciarFormulario();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    this.ConsultarAliados();
    this.ConsultarRecaudosPendientes();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      idAplicacion: [0],
      idPrograma: [0]
    });

    this.form.get('idAplicacion').valueChanges.subscribe((valorNuevo) => {
      this.ConsultarPrograma();
    });
    this.form.get('idPrograma').valueChanges.subscribe((valorNuevo) => {
      this.ConsultarRecaudos();
    });
  }
  recargarLista() {
    this.dataSource = new MatTableDataSource(this.listaDatos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ConsultarAliados() {
    this.mostrarCargando = true;
    this.recaudosService.ConsultarAliados()
              .subscribe((resp: Maestro_Aliados[]) =>{
                this.mostrarCargando = false;
                this.listaAliados = resp;

                if (this.listaAliados.length === 1) {
                  this.form.get('idAplicacion').setValue(this.listaAliados[0].idAplicacion);
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarPrograma() {
    if (this.form.get('idAplicacion').value > 0) {
      this.mostrarCargando = true;
      this.recaudosService.ConsultarProgramas(this.form.get('idAplicacion').value)
                .subscribe((resp: RecaudoPrograma[]) =>{
                  this.mostrarCargando = false;
                  this.listaRecaudosPrograma = resp;

                  this.listaDatos = [];
                  this.recargarLista();

                  if (this.listaRecaudosPrograma.length === 1) {
                    this.form.get('idPrograma').setValue(this.listaRecaudosPrograma[0].id);
                  } else {
                    this.form.get('idPrograma').setValue(0);
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    } else {
      this.listaRecaudosPrograma = [];
      this.listaDatos = [];
      this.recargarLista();
    }
  }
  ConsultarRecaudosPendientes() {
    this.mostrarCargando = true;
    this.ultimaConsulta = this.TIPO_CONSULTA_PENDIENTES;
    this.recaudosService.ConsultarRecaudosPendientes()
              .subscribe((resp: Recaudo[]) =>{
                this.mostrarCargando = false;
                this.listaDatos = resp;
                this.recargarLista();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRecaudos() {
    if (this.form.get('idPrograma').value > 0) {
      this.mostrarCargando = true;
      this.ultimaConsulta = this.TIPO_CONSULTA_NORMAL;
      this.recaudosService.ConsultarRecaudos(this.form.get('idAplicacion').value, this.form.get('idPrograma').value)
                .subscribe((resp: Recaudo[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatos = resp;
                  this.recargarLista();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    } else {
      this.listaDatos = [];
      this.recargarLista();
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  DescargarArchivoGenerado(itemSeleccionado: Recaudo) {
    this.mostrarCargando = true;
    let parametrosConsulta: FormGroup = new FormGroup({
      'idAplicacion': new FormControl(0)
      ,'idPrograma': new FormControl(0)
      ,'idRecaudo': new FormControl(0)
    });
    parametrosConsulta.get('idAplicacion').setValue(itemSeleccionado.idAplicacion);
    parametrosConsulta.get('idPrograma').setValue(itemSeleccionado.idPrograma);
    parametrosConsulta.get('idRecaudo').setValue(itemSeleccionado.id);
    this.recaudosService.DescargarArchivoGeneradoRecaudos(parametrosConsulta.value)
              .subscribe((resp: RespuestaGenerica) =>{
                if (resp.procesoExitoso) {
                  this.utilitariosService.AbrirVinculo(resp.mensaje);
                } else {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                }
                this.mostrarCargando = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  DescargarRespuesta(itemSeleccionado: Recaudo) {
    if (itemSeleccionado.estado === 'APR') {
      this.mostrarCargando = true;
      let parametrosConsulta: FormGroup = new FormGroup({
        'idAplicacion': new FormControl(0)
        ,'idPrograma': new FormControl(0)
        ,'idRecaudo': new FormControl(0)
      });
      parametrosConsulta.get('idAplicacion').setValue(itemSeleccionado.idAplicacion);
      parametrosConsulta.get('idPrograma').setValue(itemSeleccionado.idPrograma);
      parametrosConsulta.get('idRecaudo').setValue(itemSeleccionado.id);
      this.recaudosService.DescargarRespuestaRecaudos(parametrosConsulta.value)
                .subscribe((resp: RespuestaGenerica) =>{
                  if (resp.procesoExitoso) {
                    this.utilitariosService.AbrirVinculo(resp.mensaje);
                  } else {
                    this.utilitariosService.MensajeToast(resp.mensaje);
                  }
                  this.mostrarCargando = false;
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  SubirRespuesta(itemSeleccionado: Recaudo) {
    if (itemSeleccionado.estado === 'PEN' || itemSeleccionado.subirRespuestaProcesada) {
      this.itemSeleccionado = itemSeleccionado;
      this.filtroArchivo = itemSeleccionado.filtroarchivorespuesta;

      this._appseleccionararchivo.MostrarSeleccionArchivo();
    }
  }
  Anular(itemSeleccionado: Recaudo) {
    if (itemSeleccionado.estado === 'PEN' || itemSeleccionado.estado === 'APR') {
      this.itemSeleccionado = itemSeleccionado;
      this._appconfirmacion.MostrarMensajeConfirmacion();
    }
  }
  ConfirmoAnulacion(confirmo: boolean) {
    if (confirmo) {
      this.mostrarCargando = true;
      let parametrosConsulta: FormGroup = new FormGroup({
        'idAplicacion': new FormControl(0)
        ,'idRecaudo': new FormControl(0)
      });
      parametrosConsulta.get('idAplicacion').setValue(this.itemSeleccionado.idAplicacion);
      parametrosConsulta.get('idRecaudo').setValue(this.itemSeleccionado.id);

      this.recaudosService.AnularRecaudos(parametrosConsulta.value)
                .subscribe((resp: RespuestaGenerica) =>{
                  this.utilitariosService.MensajeToast(resp.mensaje);
                  this.mostrarCargando = false;
  
                  if (this.ultimaConsulta === this.TIPO_CONSULTA_PENDIENTES) {
                    this.ConsultarRecaudosPendientes();
                  } else {
                    this.ConsultarRecaudos();
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());      
    }
  }
  GenerarRecaudo() {
    this.mostrarCargando = true;
    let parametrosConsulta: FormGroup = new FormGroup({
      'idAplicacion': new FormControl(0)
      ,'idPrograma': new FormControl(0)
    });
    parametrosConsulta.get('idAplicacion').setValue(this.form.get('idAplicacion').value);
    parametrosConsulta.get('idPrograma').setValue(this.form.get('idPrograma').value);
    this.recaudosService.GenerarRecaudos(parametrosConsulta.value)
              .subscribe((resp: RespuestaGenerica) =>{
                if (resp.procesoExitoso) {
                  this.utilitariosService.AbrirVinculo(resp.mensaje);
                } else {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                }
                this.mostrarCargando = false;

                this.ConsultarRecaudos();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  SeleccionoArchivo(parametros: any) {
    if (parametros.subioArchivo) {
      this.mostrarCargando = true;
      this.recaudosService.RespuestaRecaudos(parametros.archivo, this.itemSeleccionado.idAplicacion, this.itemSeleccionado.idPrograma, this.itemSeleccionado.id)
              .subscribe((resp: RespuestaGenerica) =>{
                this.utilitariosService.MensajeToast(resp.mensaje);
                this.mostrarCargando = false;
                
                if (this.ultimaConsulta === this.TIPO_CONSULTA_PENDIENTES) {
                  this.ConsultarRecaudosPendientes();
                } else {
                  this.ConsultarRecaudos();
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    }
  }
  MarcarCompleto(itemSeleccionado: Recaudo) {
    this.itemSeleccionado = itemSeleccionado;
    this._appconfirmacionCompleto.MostrarMensajeConfirmacion();
  }
  ConfirmoCompleto(confirmo: boolean) {
    if (confirmo) {
      this.mostrarCargando = true;
      let parametrosConsulta: FormGroup = new FormGroup({
        'idAplicacion': new FormControl(0)
        ,'idRecaudo': new FormControl(0)
        ,'idPrograma': new FormControl(0)
      });
      parametrosConsulta.get('idAplicacion').setValue(this.itemSeleccionado.idAplicacion);
      parametrosConsulta.get('idRecaudo').setValue(this.itemSeleccionado.id);
      parametrosConsulta.get('idPrograma').setValue(this.itemSeleccionado.idPrograma);
      this.recaudosService.MarcarCompletadoRecaudo(parametrosConsulta.value)
                .subscribe((resp: RespuestaGenerica) =>{
                  this.mostrarCargando = false;
                  if (resp.procesoExitoso) {
                    if (this.ultimaConsulta === this.TIPO_CONSULTA_PENDIENTES) {
                      this.ConsultarRecaudosPendientes();
                    } else {
                      this.ConsultarRecaudos();
                    }
                  } else {
                    this.utilitariosService.MensajeToast(resp.mensaje);
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  TituloOpcionMenu(): string {
    return this.menuService.ObtenerTituloOpcionComponente('RecaudosComponent');
  }
}
